import { Decision, FeatureFlagDecision, MatchValueType, RemoteConfigDecision } from "../model/model"
import { EmptyParameterConfig } from "../config/ParameterConfig"
import ExperimentEvaluation from "../evaluation/service/experiment/ExperimentEvaluation"
import RemoteConfigEvaluation from "../evaluation/service/remoteconfig/RemoteConfigEvaluation"
import ObjectUtil from "../util/ObjectUtil"

/**
 * Shared mapping from an evaluation to a public decision, used by both the local and remote decision
 * processors so the mapping stays identical across modes.
 */
export const Decisions = {
  experiment(evaluation: ExperimentEvaluation): Decision {
    const config = evaluation.result.variation.config ?? new EmptyParameterConfig()
    return Decision.of(evaluation.result.variation.key, evaluation.result.reason, config, evaluation.entity)
  },

  featureFlag(evaluation: ExperimentEvaluation): FeatureFlagDecision {
    const config = evaluation.result.variation.config ?? new EmptyParameterConfig()
    return evaluation.result.variation.key === "A"
      ? FeatureFlagDecision.off(evaluation.result.reason, config, evaluation.entity)
      : FeatureFlagDecision.on(evaluation.result.reason, config, evaluation.entity)
  },

  remoteConfig(
    evaluation: RemoteConfigEvaluation,
    requiredType: MatchValueType,
    defaultValue: string | number | boolean
  ): RemoteConfigDecision {
    const value = evaluation.result.value?.rawValue
    // No server-resolved value: return the caller's default with the server reason.
    if (ObjectUtil.isNullOrUndefined(value)) {
      return RemoteConfigDecision.of(defaultValue, evaluation.result.reason)
    }
    // Cast the resolved value against the caller's required type; on mismatch fall back to the default
    // (the reason is decided by the evaluator, so the exposure event and the decision stay in sync).
    if (requiredType === "UNKNOWN" || (requiredType !== "NULL" && typeof value !== typeof defaultValue)) {
      return RemoteConfigDecision.of(defaultValue, evaluation.result.reason)
    }
    return RemoteConfigDecision.of(value, evaluation.result.reason)
  }
}
